<template>
	<v-container fluid class="blue-grey lighten-5" grid-list-lg>
			<v-row class="font-weight-black black--text mx-2 my-5">
				<h2>مستندات آموزشی</h2>
			</v-row>
			<!-- <v-divider></v-divider> -->
			<v-overlay :absolute="absolute" :opacity="opacity" :value="overlay" :z-index="zIndex"></v-overlay>
			<v-card class="font-weight-black">
				<v-card-title>
					لیست فایلها
					<v-spacer></v-spacer>
					<v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
				</v-card-title>
				<v-data-table :headers="headers" :items="items" class="docListTable" :search="search" :footer-props="footerProps" :items-per-page="itemsPerPage" item-key="documentDetailId" single-select :loading="isLoading" loading-text="Loading... Please wait">
					<!-- <v-data-table :headers="headers" :items="items" :search="search" :footer-props="footerProps" :items-per-page="10" class="elevation-1" item-key="documentDetailId" @click:row="viewDoc" single-select> -->
					<template v-slot:item.controls="props">
						<v-btn class="mx-2" fab dark small color="black" @click="viewDoc(props.item)">
							<v-icon dark>mdi-school</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</v-card>
		</v-container>
</template>

<script>
	export default {
		name: "DocsList",
		computed: {
			items() {
				return this.$store.state.docsList;
			},
		},
		watch: {
			items() {
				this.isLoading = false;
			},
		},
		data() {
			return {
				// pdfFile: "@/asset/pdf/test.pdf",
				// docFile: "",
				// docName: "",
				isLoading: true,
				absolute: false,
				opacity: 0.46,
				overlay: false,
				zIndex: 5,
				isMobile: true,
				search: "",
				itemsPerPage: 15,
				headers: [
					// { text: "شماره", align: "start", value: "documentDetailId" },
					{ text: "عنوان مستند", align: "start", value: "name" },
					{ text: "شرح", value: "desc" },
					{ text: "پروژه های مرتبط", value: "projects", align: "left" },
					// { text: "تگ لیست", value: "tags" },
					{ text: "نسخه", value: "version" },
					{ text: "تاریخ انتشار", value: "date" },
					{ text: "", value: "controls", align: "center", sortable: false },
				],
				footerProps: {
					itemsPerPageAllText: "همه",
					itemsPerPageText: "ردیف در هر صفحه",
					pageText: "",
				},
			};
		},
		mounted: function () {
			if (this.items && this.items.length > 0) this.isLoading = false;
		},
		methods: {
			async viewDoc(item) {
				this.overlay = !this.overlay;
				// console.info(0, item);
				// const tr = item.target.parentNode;
				// tr.classList.add("highlight");
				const docId = parseInt(item.documentDetailId);
				const data = {
					DocumentDetailId: docId,
					DocType: "pdf",
				};
				const fileName = `${item.name}-v${item.version}.pdf`;
				await this.$store.dispatch("getDoc", { data, fileName });
				// console.info(2, doc);
				this.overlay = !this.overlay;
			},
		},
	};
</script>
<style scoped></style>
